import { DSThemeName } from '@design-system/styles/themes/types'
import React from 'react'

export const ContextDSTheme = React.createContext<{
  themeName: DSThemeName
}>({
  themeName: DSThemeName.default
})
